import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import './styles/animations.css'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import CookieConsent from './components/CookieConsent.vue'
import { env } from './config/env'
import { logger } from './utils/logger'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// 註冊全局組件
app.component('CookieConsent', CookieConsent)

app.mount('#app')

// 開發環境：在控制台提供測試工具
if (import.meta.env.DEV) {
  import('./utils/test-analytics.js').then(({ runAllTests, testGA4Init, testPageTracking, testEventTracking, testCookieConsent }) => {
    // 將測試函數暴露到全局，方便在控制台調用
    window.testAnalytics = {
      runAll: runAllTests,
      init: testGA4Init,
      page: testPageTracking,
      event: testEventTracking,
      cookie: testCookieConsent,
    }
    
    logger.log('🧪 Analytics 測試工具已加載')
    logger.log('💡 在控制台運行以下命令進行測試：')
    logger.log('   window.testAnalytics.runAll()  - 運行所有測試')
    logger.log('   window.testAnalytics.init()   - 測試 GA4 初始化')
    logger.log('   window.testAnalytics.page()   - 測試頁面追蹤')
    logger.log('   window.testAnalytics.event()  - 測試事件追蹤')
    logger.log('   window.testAnalytics.cookie() - 測試 Cookie 同意')
  })
}

